<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch19"><a id="ch19a"></a><a id="page_44"></a><a href="#/Contents#rch19"><span class="underline">ODD VODKAS</span></a></h3>
<p class="center1"><span><i>Vodka is practically tasteless, which means that distilleries can add whatever bizarre flavors they want to it. For example…</i></span></p>
<p class="hangs"><span>•<span class="spx"><b>GRASS:</b> Polish company Bak makes Bison Grass vodka. It’s not bison-flavored—it’s grass-flavored (and bison eat grass). The grass infusion leaves a small amount of coumarin, which is a main ingredient in rat poison and leads to liver damage (but then, so does vodka).</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>HORSERADISH:</b> Sputnik, a Russian distillery, makes a vodka flavored with “pure organic horseradish.” Wasabi, another kind of horseradish, gives Green Geisha from Oregon’s Hard Times Distillery its distinctive flavor (and burn).</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>PORK:</b> Bakon vodka is infused with the flavor of pork fat. The bottle is bacon-shaped, too.</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>PICKLE:</b> Another Russian distillery, Vodka Garant, makes a pickle-and-garlic vodka. If that’s not to your taste, American distillery Naked Jay makes a pickle-flavored vodka. No garlic.</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>PEANUT BUTTER:</b> Van Goh produces a PB&amp;J vodka, while NutLiquor makes one free of jelly, just peanut butter. Both are, surprisingly, free of peanut products.</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>BUBBLE GUM:</b> A company called Three Olives makes this vodka.</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>SYRUP:</b> Birch syrup is a sweetened tree sap, similar to maple syrup and widely used in Alaska. Alaska Distillery makes a birch syrup vodka. (They also make rhubarb vodka and their most challenging flavor: smoked salmon vodka.)</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>DESSERT:</b> Pinnacle manufactures a line of dessert-inspired vodkas, including cotton candy, cupcake, cake batter, and whipped cream.</span></span></p>
<p class="hangs"><span>•<span class="spx"><b>ARACHNID:</b> Skorppio-brand vodka doesn’t have any particular extra flavor, but it does come with a real, de-poisoned scorpion, much like a worm comes in a bottle of mescal.</span></span></p>
<div class="box">
<p class="center7"><span><b>In Japan the number 4 is unlucky (it sounds like the Japanese word for death).</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter019.vue?1e387e96